import type { UseQueryOptions, UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';

import { apiClient } from 'api/apiClient';
import type { TExpectedDecisionMaker } from 'api/types/edm';
import type { IRequestException } from 'api/types/requestException';

interface IUpdateEdmProps
    extends UseQueryOptions<TExpectedDecisionMaker, IRequestException> {
    status: TExpectedDecisionMaker['status'];
    id: number;
}

export const updateEDMStatus = async ({ status, id }: IUpdateEdmProps) => {
    const response = await apiClient.patch(`edms/${id}`, {
        json: {
            status,
        },
    });
    return (await response.json()) as TExpectedDecisionMaker;
};

export const useUpdateEdmStatusMutation = (
    options: UseMutationOptions<
        TExpectedDecisionMaker,
        IRequestException,
        IUpdateEdmProps
    >
) => {
    return useMutation<
        TExpectedDecisionMaker,
        IRequestException,
        IUpdateEdmProps
    >(async (data) => await updateEDMStatus(data), options);
};
